import React from "react";
import { SERVER_URL } from "config/index";

function AttachFile({ boardFiles }) {
    return (                 
        <div>
            {boardFiles.map((item, index) => (
            <span className="file_attach">
                <li className="file-list" key={index}>
                    <a key={index}
                        href={`${SERVER_URL}/api/file/download/${encodeURIComponent(item.orignlFileNm)}`} // 서버 URL 설정
                        download={item.orignlFileNm} // 다운로드할 파일 이름 설정
                    >
                        {item.orignlFileNm}
                    </a>
                </li>
            </span>
        ))}
        </div>
    );
}

export default AttachFile;